import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/auth";
import Error403 from "../../components/Error/403";
import axios from "../../api/axios";

export default function StoreOut() {
  const [formData, setFormData] = useState({
    inventory_id: "",
    quantity: "",
  });
  const [inventoryItems, setInventoryItems] = useState([]);
  const [lastFiveStoreOut, setLastFiveStoreOut] = useState([]);
  const { user } = useContext(AuthContext);

  // Fetch inventory items for dropdown
  const fetchInventoryItems = async () => {
    try {
      const response = await axios.get("/get-inventory");
      setInventoryItems(response.data?.inventories);
    } catch (error) {
      console.error("Error fetching inventory items:", error);
    }
  };

  // Fetch last five store-out records
  const fetchLastFiveStoreOut = async () => {
    try {
      const response = await axios.get("/get-store-out");
      setLastFiveStoreOut(response.data.slice(-5).reverse());
    } catch (error) {
      console.error("Error fetching store-out records:", error);
    }
  };

  useEffect(() => {
    fetchInventoryItems();
    fetchLastFiveStoreOut();
  }, []);

  // Check user access
  // if (user) {
  //   const access = user.user?.role.find((role) => role.name === "storeOut");
  //   if (!access?.allow) {
  //     return <Error403 />;
  //   }
  // }

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put("/store-out", {
        inventory_id: formData.inventory_id,
        user_id: user.user._id, // Pass the logged-in user ID
        quantity: parseInt(formData.quantity, 10),
      });

      toast.success("Store Out Successful");
      fetchLastFiveStoreOut();
      fetchInventoryItems(); // Refresh inventory items after update
      setFormData({ inventory_id: "", quantity: "" }); // Reset form fields
    } catch (error) {
      console.error("Error in store-out:", error);
      toast.error(error.response?.data?.message || "Store Out Failed");
    }
  };

  return (
    <div className="">
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="">
              {/* Button to redirect to full store-out list */}
              <Link
                to="/store-out-list"
                className="btn btn-primary float-right"
              >
                See All Store Out Records
              </Link>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-5">
              <div className="card shadow p-3 mb-5 bg-body rounded">
                <div className="card-header">
                  <h3 className="card-title">Store Out Inventory</h3>
                </div>
                <div className="card-body mb-4">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="inventory_id">
                        Select Inventory Item
                      </label>
                      <select
                        className="form-control"
                        id="inventory_id"
                        name="inventory_id"
                        value={formData.inventory_id}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">-- Select Item --</option>
                        {inventoryItems.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.product_name} (Available: {item.quantity})
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="quantity">Quantity</label>
                      <input
                        type="number"
                        className="form-control"
                        id="quantity"
                        name="quantity"
                        placeholder="Enter quantity"
                        value={formData.quantity}
                        onChange={handleInputChange}
                        required
                        min="1"
                      />
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Store Out
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="card shadow p-3 mb-5 bg-body rounded">
                <div className="card-header">
                  <h3 className="card-title">Latest Five Store Out Records</h3>
                </div>
                <div className="card-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="text-center">Product Name</th>
                        <th className="text-center">User</th>
                        <th className="text-center">Quantity</th>
                        <th className="text-center">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastFiveStoreOut.map((record) => (
                        <tr key={record._id}>
                          <td className="text-secondary text-center">
                            {record.inventory_id?.product_name}
                          </td>
                          <td className="text-secondary text-center">
                            {record.user_id?.username}
                          </td>
                          <td className="text-secondary text-center">
                            {record.quantity}
                          </td>
                          <td className="text-secondary text-center">
                            {new Date(record.createdAt).toLocaleDateString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
